import template from './destroy.html';
import controller from './destroy.controller';
import './destroy.styl';

export const destroyComponent = {
  template,
  controller,
  controllerAs: 'destroy',
  bindings: {
    resolve : '<',
    close   : '&',
    dismiss : '&'
  }
};




/** WEBPACK FOOTER **
 ** ./frontend/components/utility/destroy/destroy.component.js
 **/